import logo from './logo.svg';
import './App.css';
import Router from './Router';
import { Container } from '@material-ui/core';
import {Loading, Header} from './components';

const App = () => {
  return (
    <div className="App">
      <Loading>
        <Header />
        <Container maxWidth="xs" style={{backgroundColor: '#cfe8fc', height: '100vh', paddingTop: '5vh'}}>
          <Router />
        </Container>
      </Loading>
    </div>
  );
}

export default App;
